import React from 'react'
import ExperienceOfferPageDispatchContext from './experienceOfferPageDispatchContext'
import ExperienceOfferPageStateContext from './experienceOfferPageStateContext'
import { ExperienceOfferPageDispatchAction, ExperienceOfferPageState } from './experienceOfferPageStateReducer'

interface Props {
  state: ExperienceOfferPageState
  dispatch: React.Dispatch<ExperienceOfferPageDispatchAction>
  children: React.ReactNode
}

function ExperienceOfferPageStateProvider(props: Props) {
  return <ExperienceOfferPageStateContext.Provider value={props.state}>
    <ExperienceOfferPageDispatchContext.Provider value={props.dispatch}>
      {props.children}
    </ExperienceOfferPageDispatchContext.Provider>
  </ExperienceOfferPageStateContext.Provider>
}

export default ExperienceOfferPageStateProvider
